import Classrooms from './Classrooms';

export default Classrooms;
